import { Link } from "react-router-dom";

export default function ProjectCard(
    {
        img,
        title,
        date,
        slug
    }
) {
    const dateInstance = new Date(date);
    const month = dateInstance.toLocaleDateString(navigator.language, { month: 'long' });
    const year = dateInstance.getFullYear();
    return (
        <Link className="w-full flex flex-col gap-[1.125rem]" to={`/realisations/${slug}`}>
            <figure className="w-full">
                <img src={img} alt={title} className="w-full aspect-[4/3] object-cover" />
            </figure>
            <div className="flex flex-col gap-[0.3rem]">
                <h4 className="text-very-large font-[700]">
                    {title}
                </h4>
                <h5 className="text-regular font-[500] opacity-50">
                    {month} {year}
                </h5>
            </div>
        </Link>
    )
}